module.exports = __webpack_public_path__ + "img/0371c58a4ae30b19b988c21ebcbeaf1f.943e02ba.jpeg";